import PlanPage from '../pages/Billing/PlanPage';
import StatementsPage from '../pages/Billing/StatementsPage';
import { OWNER_ABOVE } from '../constants/roles';
import RoleProtectedRoute from '../components/RoleProtectedRoute';
import type { AppRoute } from './types';

export const billingRoutes: AppRoute[] = [
    { path: 'plan', element: <RoleProtectedRoute allowedRoles={OWNER_ABOVE} Component={PlanPage} /> },
    { path: 'statements', element: <RoleProtectedRoute allowedRoles={['Admin']} Component={StatementsPage} /> },
];
